import ToggleDescriptionListItem from './ToggleDescriptionListItem';

import './ToggleDescriptionList.scss';

const ToggleDescriptionList = (props) => <ol {...props} />;
ToggleDescriptionList.Item = ToggleDescriptionListItem;

export default ToggleDescriptionList;
